<template>
  <div @mouseover="active = true" @mouseleave="active = false">
    <router-link :id="prod.id" :to="'/product/' + prod.id" v-html="prod.Titel"></router-link><div style="display:inline;"><span v-show="active" v-html="prod.Untertitel"></span></div>
  </div>
</template>
<script>
  export default {
    name: 'ProductEn',
    data () {
      return {
        active: false
      }
    },
    props: ['prod']
  }
</script>
<style scoped>
  h1,h2 {
    color: black;
  }
  ul {
    list-style: none;
  }
  li {
    color: black;
  }
  span {
    margin-left: 10px; 
  }
  .show {
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/product_en.vue